<div class="flex md:flex-row flex-col gap-6 items-center justify-between mb-6">
  <h2 class="self-start">{{'personalizedJourney.title' | transloco}}</h2>
  <div class="flex flex-col gap-[0.8rem] items-end self-end">
    <progression-bar />
    <app-button
      [text]="'personalizedJourney.clarify.resetResearch' | transloco"
      [variant]="'secondary'"
      [icon]="'back'"
      [iconSize]="'1.5rem'"
      [size]="'sm'"
      (buttonClick)="redirectToJourneyResearch()"
    ></app-button>
  </div>
</div>

<div class="flex flex-col gap-6 mb-20">
  <app-journey-breadcrumb />
  <div
    class="flex flex-col gap-4 md:gap-10 py-6 px-4 md:p-6 rounded-xl mb-6 bg-white"
  >
    <h3>{{ 'personalizedJourney.exchange.title' | transloco }}</h3>
    <div class="flex flex-col gap-6 md:gap-10 p-4 bg-vinciLavender rounded-xl">
      <h3 class="flex items-center gap-5">
        <icon [name]="'messages'" [size]="'1.875rem'"></icon>
        {{ 'personalizedJourney.exchange.myMobilityRefs' | transloco }}
      </h3>
      <p>{{ 'personalizedJourney.exchange.subtitle' | transloco }}</p>
      @if(mobilityRefsLoading()) {
      <loader />
      } @else {
      <app-language-filter
        [availableLanguages]="availableLanguages()"
        [textToDisplayIfAnySelected]="'personalizedJourney.exchange.languagesSpoken' | transloco"
        (updateResults)="updateResults($event)"
      ></app-language-filter>
      @if(mobilityRefstoDisplay().length === 0){
      <p class="text-center">
        {{ 'personalizedJourney.exchange.noRefFound' | transloco }}
      </p>
      } @else {
      <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
        @for (mobilityRef of mobilityRefstoDisplay(); track $index) {
        <app-contact-card
          [spId]="mobilityRef.spId"
          [name]="mobilityRef.firstName + ' ' + mobilityRef.lastName"
          [job]="mobilityRef.job"
          [mail]="mobilityRef.mail"
          [phoneNumber]="mobilityRef.phoneNumber"
          [languages]="mobilityRef.languages"
          [location]="mobilityRef.location"
          [bookingLink]="mobilityRef.bookingCalendarLink"
          [allowSaving]="true"
        ></app-contact-card
        >}
      </div>
      } }
    </div>
  </div>
</div>
